module.exports = __webpack_public_path__ + "img/winerackdog13.ee93e411.jpg";